import { MaterialService } from './../../service/material.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../../service/authentification.service';
import { FormGroup, FormControl, FormBuilder, Validators, ValidationErrors } from '@angular/forms';
import { AbstractControl } from '@angular/forms';
import { Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss', '../login/login.ux.scss']
})
export class ResetPasswordComponent implements OnInit, OnDestroy {

  uid;
  token;
  password1 = new FormControl('', [Validators.required, Validators.minLength(8), ResetPasswordComponent.passwordValidator]);
  password2 = new FormControl('', [Validators.required, Validators.minLength(8), ResetPasswordComponent.passwordValidator]);
  formChanges = false;
  passwordForm: FormGroup;
  site: string;

  loading = false;

  private _unsubscribeAll: Subject<any> = new Subject<any>();

  static passwordValidator(control) {
    // RFC 2822 compliant regex
    if (control.value) {
      if (control.value.length > 7) {
        return null;
      }
    } else {
      return { 'emptyPassword': true };
    }
  }

  static MatchPassword(AC: AbstractControl): ValidationErrors | null {
    const password = AC.get('password1').value; // to get value in input tag
    const confirmPassword = AC.get('password2').value; // to get value in input tag
    if (password !== confirmPassword) {
      AC.get('password2').setErrors({ MatchPassword: true })
    } else {
      return null
    }
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private builder: FormBuilder,
    private materialService: MaterialService,
  ) { }

  ngOnInit() {
    this.passwordForm = this.builder.group({
      password1: this.password1,
      password2: this.password2,
    }, {
      validators: [ResetPasswordComponent.MatchPassword]
    });
    

    this.uid = this.route.snapshot.params['uid'];
    this.token = this.route.snapshot.params['token'];
    this.route.data.subscribe(data => {
      this.site = data.site;
    });

    this.subcribeToFormChanges();
  }

  subcribeToFormChanges() {
    // initialize stream
    const myFormValueChanges$ = this.passwordForm.valueChanges;

    // subscribe to the stream
    myFormValueChanges$.subscribe(data => {
      this.formChanges = true;
    })
  }

  ngOnDestroy() {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  sendNewPassword() {
    if (!this.passwordForm.valid) {
      return;
    }
    this.loading = true;
    this.authenticationService.sendNewPassword(this.uid, this.token, this.password1.value, this.password2.value)
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe({
        next: () => {
          this.materialService.openSnackBar('Mot de passe modifié', 'green');
          this.router.navigate(['login']);
          this.loading = false;
        },
        error: () => {
          this.materialService.openSnackBar('Une erreur est survenue', 'red');
          this.loading = false;
        }
      })
  }
}
